import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import BuyerSaler from "./BuyerSaler";
import LiveMints from "./LiveMints";
import LiveSales from "./LiveSales";
import MarketPlace from "./MarketPlace";
import Sales from "./Sales";

const TokenTabs = () => {
  const [key, setKey] = useState("volume");
  return (
    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3 tab-btn-group"
      //   role={"navigation"}
      // className="tab-btn-group"
    >
      <Tab
        eventKey="volume"
        title="Sales Volume"
        tabClassName="tab-btn"
        // className={"active"}
      >
        <Sales />
      </Tab>
      <Tab eventKey="sales" title="Live Sales" tabClassName="tab-btn">
        <LiveSales />
      </Tab>
      <Tab
        eventKey="marketplace"
        title="Live Marketplace"
        tabClassName="tab-btn"
      >
        <MarketPlace />
      </Tab>
      <Tab eventKey="mints" title="Live Mints" tabClassName="tab-btn">
        <LiveMints />
      </Tab>
      <Tab
        eventKey="buyersaler"
        title="Market Buyers / Sellers"
        tabClassName="tab-btn"
      >
        <BuyerSaler />
      </Tab>
    </Tabs>
  );
};

export default TokenTabs;
